import { getData, removeData, storeData } from './util_helpers';
import AsyncStorage from '@react-native-async-storage/async-storage';
import GLOBAL from '../configs/config_global';

// region Function - Generate Unique ID
export function generateUniqueId(userID = '') {
    const userAgent = window.navigator.userAgent;
    const randomString = Math.random().toString(20).substring(2, 14) + Math.random().toString(20).substring(2, 14);
    return(`${userAgent}-${userID}-VendorWeb-${randomString}`);
}
// endregion

export function saveUniqueID(userID = '') {
    getData('uniqueIDs')
        .then((resultObj) => {
            const obj = JSON.parse(resultObj || '{}');
            if (!obj[userID]) {
                obj[userID] = generateUniqueId(userID);
                storeData('uniqueIDs', JSON.stringify(obj)).then(() => {});
            }
        });
}

export function removeUniqueID(userID = null) {
    if (userID === null) {
        removeData('uniqueIDs');
    }
    else {
        getData('uniqueIDs')
            .then((resultObj) => {
                const obj = JSON.parse(resultObj || '{}');
                if (obj[userID]) {
                    delete obj[userID];
                    storeData('uniqueIDs', JSON.stringify(obj)).then(() => {});
                }
            });
    }
}

export function retrieveUniqueID(userID = '') {
    return new Promise((resolve) => {
        getData('uniqueIDs')
            .then((resultObj) => {
                const obj = JSON.parse(resultObj | '{}');
                resolve(obj[userID] || null);
            })
    });
}

export function saveToken(token, service, userData) {
    let saveObj = {
        'token': token,
        'service': service,
        'data': userData
    };

    return new Promise((resolve) => {
        // Retrieve current token in local storage
        // (to support multiple accounts)
        getData('currentToken')
            .then((resultObj) => {
                let accountList;
                if (resultObj) {
                    let currentTokenObj = JSON.parse(resultObj || '{}');
                    accountList = Array.isArray(currentTokenObj) ? currentTokenObj : [currentTokenObj];
                }
                else accountList = [];

                // Check if current array already contain this user data
                // if yes, update its value
                let accountIndex = accountList.findIndex((account) => account.data.id === userData.id);
                if (accountIndex > -1) {
                    accountList.splice(accountIndex, 1, saveObj);
                }
                else accountList.push(saveObj);

                // Start saving new array of accounts to local storage
                AsyncStorage.setItem('currentToken', JSON.stringify(accountList))
                    .then(() => {
                        console.log('[SUCCESS] SAVE TOKEN', accountList);
                        resolve('Done');
                    })
                    .catch((error) => {
                        console.log('[ERROR] SAVE TOKEN', error);
                        resolve(null);
                    });
            });
    });
}

export function removeToken(userID = GLOBAL.DATA.USER.id) {
    return new Promise((resolve) => {
        // Retrieve current token in local storage
        // just in case use has multiple accounts
        getData('currentToken')
            .then((resultObj) => {
                let accountList;
                if (resultObj) {
                    let currentTokenObj = JSON.parse(resultObj || '{}');
                    accountList = Array.isArray(currentTokenObj) ? currentTokenObj : [currentTokenObj];
                }
                else accountList = [];

                // Check if this account is in the list, if yes then remove it
                let accountIndex = accountList.findIndex((account) => account.data.id === userID);
                if (accountIndex > -1) {
                    accountList.splice(accountIndex, 1);
                }

                // Start saving new array of accounts to local storage
                if (accountList.length > 0) {
                    storeData('currentToken', JSON.stringify(accountList))
                        .then(() => {
                            console.log('[SUCCESS] SAVE TOKEN', accountList);
                            resolve(accountList);
                        });
                }
                else {
                    removeData('currentToken');
                    resolve(null);
                }
            });
    });
}
